export default __webpack_public_path__ + "static/media/060_corner2_01.416d261e.mp3";